const now = new Date();
const talks = [
  {
    id: "2023-80",
    title: "Ankunft",
    year: "2023",
    date: "2023-07-15",
    time: "09:00",
    speakers: [],
  },
  {
    id: "2023-81",
    title: "Begrüßung",
    year: "2023",
    date: "2023-07-15",
    time: "09:30",
    speakers: [],
  },
  {
    id: "2023-01",
    title:
      "Sexuelle Gewalt in Kindheit und Jugend: Was erwarten Betroffene? Was muss sich ändern?",
    image: "/assets/talk-1.png",
    year: "2023",
    date: "2023-07-15",
    time: "09:45",
    speakers: [
      {
        name: "Prof. Dr. Barbara Kavemann, Sozialwissenschaftlerin",
        image: "/assets/speaker-2023-01.png",
      },
    ],
    homepage: null,
    zoom: null,
    youtube: null,
    description:
      "Sexuelle Gewalt gegen Kinder und Jugendliche war lange kein Thema in der Öffentlichkeit, obwohl seit den 1980er Jahren Frauen über diese Übergriffe in ihrer Kindheit, vor allem durch Familienangehörige, gesprochen haben. Mit dem sog. „Missbrauchsskandal“ 2010 begann sich das zu ändern. Inzwischen ist die große Dimension dieses Problems bekannt, es kommen ständig neue Erkenntnisse in die öffentliche Diskussion. Die Kirchen, die Heimerziehung, der Sport, alle müssen sich ihrer Vergangenheit stellen und ihre gegenwärtige Praxis überprüfen. Dieser Fortschritt im Kinderschutz ist vor allem den Betroffenen zu verdanken, die den Mut gefasst und öffentlich über die Gewalt gesprochen haben. Mehrere Forschungsar- beiten haben die Perspektive der Betroffenen erfragt, der Vortrag präsentiert die Ergebnisse: Was hat sie bewegt, die Anstrengung auf sich zu nehmen und das Schweigen zu brechen? Was erwarten sie von der Gesellschaft und ihren Institutionen? Welche Erfahrungen machen sie, wenn sie sprechen? Welche Unter- stützung wird gebraucht? Kann es Gerechtigkeit geben? Als Mitglied der Unabhängigen Kommission zur Aufarbeitung von sexuellem Kindesmissbrauch setze ich mich mit der Frage auseinander, wie wir aus den Geschichten der Betroffenen für einen zukünftig besseren Kinderschutz lernen können.",
    background:
      "Prof. Dr. Barbara Kavemann ist Honorarprofessorin an der Katholischen Hochschule für Sozialwesen Berlin und Mitarbeiterin im Sozialwissenschaftlichen Forschungsinstitut zu Geschlechterfragen in Freiburg. Ihre Themenschwerpunkte sind sexuelle Gewalt in Kindheit und Jugend sowie Gewalt in Paarbeziehungen. Als Soziologin forscht sie qualitativ, auch praxis- begleitend und evaluierend, wenn immer möglich partizipativ und legt Wert auf Trans- fer von Forschungsergebnissen in die Praxis. Sie ist seit Beginn 2016 Mitglied der Unabhängigen Kommission zur Aufarbeitung von sexuellem Kindesmissbrauch.",
  },
  {
    id: "2023-82",
    title: "Pause",
    year: "2023",
    date: "2023-07-15",
    time: "11:15",
    speakers: [],
  },
  {
    id: "2023-02",
    title: "gewalt.macht.männlich",
    image: "/assets/talk-1.png",
    year: "2023",
    date: "2023-07-15",
    time: "11:30",
    speakers: [
      {
        name: "Andreas Schmiedel, Münchner Informationszentrum für Männer MIM",
        image: "/assets/speaker-2023-04.png",
      },
    ],
    homepage: null,
    zoom: null,
    youtube: null,
    description:
      "Andreas Schmiedel macht speziell aus Täterarbeitssicht die Zusammenhänge zwischen Gewaltausübung und Mann sichtbar. Der Fokus liegt bei diesem Fachtag darauf, wie die Frauenunterstützung von diesen Erkenntnissen profitieren kann.\n\nPraktisch heißt das, die betroffenen Frauen und sehr oft auch deren Unterstützerinnen erleben die Gewalttäter als unberechenbare Monster, die nicht zu stoppen sind.\n\nDie Gewalttäter haben in aller Regel aber klar erkennbare Handlungsmuster und die Gewaltdynamik folgt einer Logik — das heißt, sie sind unter Umständen in ihrer eigenen Dynamik „lenkbar“",
    background:
      "Andreas Schmiedel ist Diplom-Sozialpädagoge (FH) mit den Schwerpunkten geschlechtsspezifischer Jungen- & Männerarbeit, Anti-Aggressivitäts-Training®, Selbstbehauptungs- und Deeskalationstraining. Er leitet die Fachstelle des MIM (Männer Informationszent- rum München) und bietet dort Beratung bei Partnerschaftsgewalt, Elternberatung bei häuslicher Gewalt im Münchener Modell und Täterarbeit bei sexualisierter Gewalt gegen Kinder, Bera- tung für Männer, die von Häuslicher Gewalt betroffen sind und für Männer, die in der Kindheit von sexuali- sierter Gewalt betroffen waren. Er war Vorstand der Bundesarbeitsgemeinschaft Täterarbeit Häusliche Ge- walt und ist seit 2017 Ausbilder von Täterarbeiter*innen Häusliche Gewalt (FTHG®)",
  },

  {
    id: "2023-83",
    title: "Mittagspause",
    year: "2023",
    date: "2023-07-15",
    time: "13:00",
    speakers: [],
  },
  {
    id: "2023-03",
    title:
      "Auswirkungen von häuslicher Gewalt auf Kinder — Rolle der Jugendämter",
    image: "/assets/talk-1.png",
    year: "2023",
    date: "2023-07-15",
    time: "14:00",
    speakers: [
      {
        name: "Dr. Susanne Heynen, Leitung Jugendamt Stuttgart",
        image: "/assets/speaker-2023-03.png",
      },
    ],
    homepage: null,
    zoom: null,
    youtube: null,
    description:
      "Nicht erst seit der bundesweiten repräsentativen Befragung zu Gewalt in der Partnerschaft (BMFSFJ, 2004) verfügen wir über differenzierte Informationen über Häufigkeit, Gewaltumstände und Dynamiken häuslicher Gewalt, über die direkten und indirekten Gewaltopfer, die betroffenen Kinder und die Gewalttätigen. Besonders gefährdet sind junge Frauen, Schwangere und Frauen mit kleinen Kindern, die Gewalt durch den Ex-/Partner erfahren. Sogenannte kritische Lebensereignisse wie Trennung und Scheidung erhöhen das Gewalt- und Tötungsrisiko. Gleichzeitig haben sowohl der getrennte Elternteil (in der Regel der Vater), als auch die Kinder ein Recht auf Umgang mit beiden Eltern, wenn es dem Kindeswohl nicht widerspricht.\n\nDer Vortrag legt den Fokus auf die von der Gewalt betroffenen jungen Menschen. Sie haben ein Recht auf gewaltfreie Erziehung sowie auf Beteiligung, Beratung Unterstützung und Schutz. Es wird aufgezeigt, wie bedeutsam ein genaues Verständnis für die Lebensbedingungen, familiären Dynamiken und unterschiedlichen Perspektiven von Müttern, Vätern und Kindern sind, welche Unterstützung die Jugendhilfe bietet und welche Pflichten für den Schutz der Kinder seitens des Jugendamtes bestehen. Erst wenn der Schutz vor Gewalt und die Bewältigung der Gewaltfolgen sichergestellt sind, eröffnen sich den Betroffenen neue und positive Perspektiven. Damit dies gelingt, müssen die Familienmitglieder und verantwortlichen Institutionen (wie Polizei, Jugendamt, Beratungsstellen, Frauenhäuser und Familiengericht) konstruktiv zusammenarbeiten.",
    background:
      "Dr. Susanne Heynen ist Dipl.-Psychologin und seit 2016 Leiterin des Jugendamtes Stuttgart. Zuvor war sie über 20 Jahre lang Mitarbeiterin der Sozial- und Jugendbehörde der Stadt Karlsruhe als Psychologische Beraterin beim Psychosozialen Dienst, Leiterin des Kinderbüros und Leiterin des Jugendamts Karlsruhe. Sie ist bekannte Referentin, Fachautorin und Mitglied in verschiedenen Gremien mit den Schwerpunkten Jugendhilfe, Kinderschutz, häusliche und sexualisierte Gewalt",
  },
  {
    id: "2023-84",
    title: "Pause",
    year: "2023",
    date: "2023-07-15",
    time: "15:30",
    speakers: [],
  },
  {
    id: "2023-04",
    title: "Gewalt macht kalt und krank",
    image: "/assets/talk-1.png",
    year: "2023",
    date: "2023-07-15",
    time: "15:45",
    speakers: [
      {
        name:
          "Dr. Lutz-Ulrich Besser, Facharzt für Psychiatrie, Traumatherapeut",
        image: "/assets/speaker-2023-02.png",
      },
    ],
    homepage: null,
    zoom: null,
    youtube: null,
    description:
      "EMDR-Europa Trainer für EMDR mit Kindern und Jugendlichen TRE - Provider „Trauma Releasing Exercise“ nach David Berceli Gründer und Leiter des zptn. Seit 1998 Vorträge und Workshops u.a. auf internationalen Traumakongressen in Köln und Göttingen, der Deutschen Fachtagung, der deutschen Gesellschaft gegen Kindesmisshandlung und Vernachlässigung in 2000 und auf dem Weltkongress für Familientherapie in Düsseldorf sowie auf dem internationalen EMDRIA-Kongress in Brüssel (2005) und der Fachtagung der DeGPT in Dresden (2005), Key-speaker auf dem WCP-Weltkongress für Psychotherapie in Wien (2002).\n\nSeit 1998 Dozent und Trainer zahlreicher Fortbildungsseminare und Curricula in Allgemeiner und Spezieller Psychotraumatologie und traumazentrierter Psychotherapie in Deutschland, Luxemburg, der Schweiz und Österreich, Bosnien- Herzegowina, Kosovo, Palästina, Irak/Kurdistan und Brasilien.",
    background:
      "Dr. Lutz-Ulrich Besser ist Facharzt für Psychiatrie und Psychotherapie, für psychotherapeutische Medizin und für Kinder- & Jugendpsychiatrie. Zudem bietet er Paar- und Familientherapie, Körpertherapie und „Spezielle Psychotraumatherapie“ (DeGPT). Er arbeitet als EMDR Trainer und leitet das zptn (Zentrum für Psychotraumatologie und Traumatherapie Niedersachsen). Seit 1998 ist er Dozent und Trainer zahlreicher Fortbildungsseminare und Curricula in Allgemeiner und Spezieller Psychotraumatologie und traumazentrierter Psychotherapie in Deutschland, Lu- xemburg, der Schweiz und Österreich, Bosnien-Herzegowina, Kosovo, Palästina, Irak/Kurdistan und Brasilien.",
  },
  {
    id: "2023-92",
    title: "Fazit und Abschluss",
    year: "2023",
    date: "2023-07-15",
    time: "17:15",
    speakers: [],
  },
].map((talk) => {
  var speakerNames = [];
  var speakerImages = [];
  var date = new Date(talk.date);
  var eod = date.setHours(23, 59, 59, 999);

  (talk.speakers || {}).forEach((speaker) => {
    if (speaker.name && speaker.name != "") {
      speakerNames.push(speaker.name);
    }
    if (speaker.image && speaker.image != "") {
      speakerImages.push(speaker.image);
    }
  });

  talk.speakerNames = speakerNames;
  talk.speakerImages = speakerImages;

  talk.localDate = date.toLocaleDateString();
  talk.pastEvent = now > eod;

  return talk;
});

const Data = {
  install(Vue) {
    Vue.prototype.$_talks = function() {
      return talks;
    };

    Vue.prototype.$_talk = function(id) {
      return talks.find((talk) => {
        return talk.id === id;
      });
    };
  },
};

export default Data;
